import Vuex from 'vuex';

import App from '../App.vue';
import { createApp } from 'vue';

const app = createApp(App);

app.use(Vuex);

export default new Vuex.Store({
    state: {
        isLoading: '',
        managerAccessToken: '',
        companyLogo: '',
        companyTitle: '',
        avatar: '',
        username: '',
        selectedProjectId: '',
        selectedServiceLogo: '',
        selectedServiceId: '',
        selectedServiceReviewStudio: '',
        services: [],
        projects: [],
        companies: [],
        selectedOwnerName: "",
        hasNotification: false,
    },
    mutations: {
        mutationer(state, payload) {
            let keys = Object.keys(payload);
            for (let item of keys) {
                state[item] = payload[item];
            }
        },
    },
});
